import baseMessage from './baseMessage'

export const ES_TT = {
  message: {
    ...baseMessage,
    label: {
      dni: 'Registration Number',
      userHint: 'Se puede buscar por Nombres, Apellidos, Registration Number'
    }
  }
}
